var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLashUpper = function SvgLashUpper(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 38,
    height: 30,
    viewBox: "0 0 0.72 0.57",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".str0{stroke:#000;stroke-width:.1;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.9256}.fil0{fill:none}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2313488647600"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil0 str0",
    d: "M.65.37C.68.38.59.44.55.46.33.59.23.51.05.36.23.21.4.21.65.37zM.14.28C.12.23.07.13.05.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0 str0",
    d: "M.35.25C.32.16.32.14.32.05M.57.31C.58.27.64.06.67.06"
  })))));
};

export default SvgLashUpper;